import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { Amount } from "models/utilTypes/currencyType";
import { ReceiptSimilarListProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import { ViewPanel, Icon, useMountedState, TableAsync } from "components/common";
import ReceiptStatusTags from "./statusTags";
import { Typography } from "@mui/material";
import { useReceiptService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import { useNavigate, useLocation } from "react-router-dom";

const ReceiptSimilarList: React.FC<ReceiptSimilarListProps> = (props) => {
  const receiptService = useReceiptService();
  const { getMounted } = useMountedState();
  const location = useLocation();
  const navigate = useNavigate();

  const [receipts, setReceipts] = React.useState<WintSuperkollAPIModel.ReceiptsSimilarItem[]>();

  React.useEffect(() => {
    receiptService.getSimilarReceipts(props.id).then((result) => {
      getMounted() && setReceipts(result);
    });
  }, [props.id]);

  const onRowClick = (row: WintSuperkollAPIModel.ReceiptsSimilarItem) => {
    navigate(UrlHelper.formatPath(`/Receipt/${row.id}`), {
      state: { background: location },
    });
  };

  return (
    <>
      {receipts && receipts.length > 0 && (
        <ViewPanel
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Similar)}
          icon={IconDefinitionConstants.WDocument}
        >
          <>
            <Typography className={cssExports.recentItemsText}>
              <Icon icon={IconDefinitionConstants.WBolt} />
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SimilarSuggestionText, undefined, {
                itemCount: `${receipts.length}`,
              })}
            </Typography>
            <TableAsync<WintSuperkollAPIModel.ReceiptsSimilarItem>
              properties={{
                date: {
                  description: TranslationKeys.Common.Date,
                  formatter: (values: WintSuperkollAPIModel.ReceiptsSimilarItem) =>
                    values.date && new Date(values.date),
                  noWrap: true,
                },
                refersTo: {
                  description: TranslationKeys.Common.RefersTo,
                },
                sender: {
                  description: TranslationKeys.Common.Sender,
                },
                amount: {
                  description: TranslationKeys.Common.Amount,
                  formatter: (values: WintSuperkollAPIModel.ReceiptsSimilarItem) =>
                    new Amount(values.currency, values.amount),
                  alignment: "right",
                  className: cssExports.textBlack,
                },
                state: {
                  description: TranslationKeys.Common.Status,
                  formatter: (values: WintSuperkollAPIModel.ReceiptsSimilarItem) => (
                    <ReceiptStatusTags status={values.state} />
                  ),
                },
              }}
              filter={receipts}
              rowClickHandler={onRowClick}
              pagination={false}
            />
          </>
        </ViewPanel>
      )}
    </>
  );
};

export default ReceiptSimilarList;
